import { CommonModule } from '@angular/common';
import { Component, inject, signal, HostListener } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MenuService, MenuItem } from '../../core/menu/menu.service';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
  host: {
    '[class.menu-open]': 'isMobileMenuOpen()'
  }
})
export class Sidebar {
  private menuService = inject(MenuService);
  
  isExpanded = signal(false);
  isMobileMenuOpen = signal(false);
  expandedSubmenus = signal<Set<string>>(new Set());
  isMobile = signal(false);

  get menuItems(): MenuItem[] {
    return this.menuService.visibleItems;
  }

  getIcon(name: string): string {
    return this.menuService.getIcon(name);
  }

  toggleSubmenu(label: string): void {
    const current = this.expandedSubmenus();
    const newSet = new Set(current);
    if (newSet.has(label)) {
      newSet.delete(label);
    } else {
      newSet.add(label);
    }
    this.expandedSubmenus.set(newSet);
  }

  isSubmenuExpanded(label: string): boolean {
    return this.expandedSubmenus().has(label);
  }

  hasSubmenu(item: MenuItem): boolean {
    return !!item.submenu && item.submenu.length > 0;
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen.set(!this.isMobileMenuOpen());
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen.set(false);
  }

  ngOnInit(): void {
    this.checkMobile();
  }

  private checkMobile(): void {
    const isLandscape = window.innerWidth > window.innerHeight;
    const isNarrow = window.innerWidth < 768;
    const isVeryShort = window.innerHeight < 400;
    const isNarrowLandscape = isLandscape && window.innerWidth < 992;
    this.isMobile.set(isNarrow || isNarrowLandscape || isVeryShort);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkMobile();
  }
}
